import Cookies from 'js-cookie';
import {
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  LOAD_DATA_FROM_LOCAL_STORAGE,
  USER_LOG_OUT,
  SET_MEMBER_USERID,
  SET_MEMBER_NICKNAME,
  SET_MEMBER_GENDER,
  SET_MEMBER_DESCRIPTION,
  REQUEST
} from '../actions/action_types';
import {
  SET_SWITCH_ACCOUNT,
  UPLOAD_AVATAR,
  GET_PORFILE
} from '../actionTypes/profile';
import { LOGIN_TYPE } from '../constants/login';
import { postSystemLog } from '../apis/system';
import { RESET_IS_REGISTER } from '../actionTypes/reset';
import { UPDATE_FIRST_LOGIN } from '../actionTypes/login';
import { hasDiffAccountIdOnPlannerTool } from '../utilities/account';
import {
  dropFunlidayCookie,
  setFunlidayCookie
} from '../utilities/funlidayCookie';

const initState = {
  isLogin: false,
  data: {},
  accessToken: { token: null, validDate: null },
  error: null,
  isRegister: false,
  updateFirstLoginInfo: {
    state: REQUEST.INIT,
    errorCode: null
  },
  ownsAccount: []
};

export default (state = initState, action) => {
  switch (action.type) {
    case USER_LOGIN_SUCCESS:
      return handleLoginSuccess(state, action.payload);
    case USER_LOGIN_FAIL:
      postSystemLog(
        'member_reducer',
        {
          type: USER_LOGIN_FAIL,
          payload: action.payload
        },
        'error'
      );
      return {
        ...state,
        error: action.payload
      };
    case SET_SWITCH_ACCOUNT.SUCCESS:
      return handleSwitchSuccess(state, action.payload);
    case LOAD_DATA_FROM_LOCAL_STORAGE:
      return handleLoadDataFromLocalStorage(state, action.payload);
    case USER_LOG_OUT:
      return handleLogout();
    case SET_MEMBER_USERID:
      // 重整時會取 localStorage 的會員資料故也要寫入
      localStorage.setItem(
        'member',
        JSON.stringify({
          ...state.data,
          userid: action.payload.userid,
          userid_modified: action.payload.userid_modified
        })
      );
      return {
        ...state,
        data: {
          ...state.data,
          userid: action.payload.userid,
          userid_modified: action.payload.userid_modified
        }
      };
    case SET_MEMBER_NICKNAME:
      return handleMemberNickName(state, action);
    case SET_MEMBER_GENDER:
      return handleMemberGender(state, action);
    case SET_MEMBER_DESCRIPTION:
      return handleMemberDescription(state, action);
    case UPLOAD_AVATAR.SUCCESS: {
      const avatar = action.avatar;

      return handleAvatar(state, avatar);
    }
    case GET_PORFILE.SUCCESS: {
      const avatar = action.data?.avatar;
      const isMe = action.data?.isMe;

      if (isMe) {
        return handleAvatar(state, avatar);
      }

      return state;
    }
    case RESET_IS_REGISTER: {
      return {
        ...state,
        isRegister: false
      };
    }
    case UPDATE_FIRST_LOGIN.LOADING:
      return {
        ...state,
        updateFirstLoginInfo: {
          ...state.firstLogin,
          state: REQUEST.LOADING
        }
      };
    case UPDATE_FIRST_LOGIN.SUCCESS:
      return {
        ...state,
        updateFirstLoginInfo: {
          ...state.firstLogin,
          state: REQUEST.SUCCESS
        }
      };
    case UPDATE_FIRST_LOGIN.FAIL:
      return {
        ...state,
        updateFirstLoginInfo: {
          ...state.updateFirstLoginInfo,
          state: REQUEST.FAIL,
          errorCode: action.payload?.status
        }
      };
    default:
      return state;
  }
};

const handleLoginSuccess = (state, payload) => {
  const {
    results,
    accessToken,
    validDate,
    expiredAt,
    isMasterAccessLogin,
    isRegister
  } = payload;
  console.table(payload);
  localStorage.setItem(
    'accessToken',
    JSON.stringify({ token: accessToken, validDate, expiredAt })
  );

  localStorage.setItem('member', JSON.stringify(results));

  setFunlidayCookie('memberId', results._id);

  // 用來保存登入帳號 _id ,Switch Member 會用到
  if (isMasterAccessLogin && hasDiffAccountIdOnPlannerTool) {
    const masterAccount = { id: results._id, accessToken };
    localStorage.setItem('masterAccount', JSON.stringify(masterAccount));
    // console.log(
    //   '~🚀~ set localStorage -> masterAccount Success ',
    //   masterAccount,
    // );
  }

  return {
    ...state,
    isLogin: true,
    data: results,
    accessToken: { token: accessToken, validDate, expiredAt },
    isRegister: isRegister || false
  };
};

/*
p: planner tool

login status
    guest login   normal login
p   true          true

web false         true
*/
const handleLoadDataFromLocalStorage = (state, payload) => {
  const {
    member,
    accessToken: { token, validDate },
    isPlannerTool
  } = payload;

  const isGuestAccountLogin = member?.loginType === LOGIN_TYPE.GUEST;
  const isLogin = !(!isPlannerTool && isGuestAccountLogin);

  return {
    ...state,
    isLogin,
    data: member,
    accessToken: { token, validDate }
  };
};

const handleLogout = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('member');
  localStorage.removeItem('masterAccount');
  localStorage.removeItem('ownsAccount');
  localStorage.removeItem('buyerCache');
  localStorage.removeItem('accountFollowings');
  localStorage.removeItem('funliday_hasLoggedin');
  dropFunlidayCookie('memberId');
  dropFunlidayCookie('accessToken');
  dropFunlidayCookie('no-oauth-prompt');
  // google one tap modal
  Cookies.set('g_state', '', { expires: 0 });
  return initState;
};
const handleSwitchSuccess = (state, payload) => {
  const { results, accessToken, validDate, expiredAt } = payload;
  localStorage.setItem(
    'accessToken',
    JSON.stringify({ token: accessToken, validDate, expiredAt })
  );
  localStorage.setItem('member', JSON.stringify(results));

  setFunlidayCookie('memberId', results._id);

  return {
    ...state,
    isLogin: true,
    data: results,
    accessToken: { token: accessToken, validDate, expiredAt }
  };
};

const handleMemberNickName = (state, action) => {
  const { nickname } = action.payload;

  // 重整時會取 localStorage 的會員資料故也要寫入 member
  localStorage.setItem(
    'member',
    JSON.stringify({
      ...state.data,
      nickname
    })
  );

  return {
    ...state,
    data: {
      ...state.data,
      nickname
    }
  };
};

const handleMemberGender = (state, action) => {
  console.log(action.payload);
  const { gender } = action.payload;

  // 重整時會取 localStorage 的會員資料故也要寫入 member
  localStorage.setItem(
    'member',
    JSON.stringify({
      ...state.data,
      gender
    })
  );

  return {
    ...state,
    data: {
      ...state.data,
      gender
    }
  };
};

const handleMemberDescription = (state, action) => {
  console.log(action.payload);
  const { description } = action.payload;

  // 重整時會取 localStorage 的會員資料故也要寫入 member
  localStorage.setItem(
    'member',
    JSON.stringify({
      ...state.data,
      description
    })
  );

  return {
    ...state,
    data: {
      ...state.data,
      description
    }
  };
};

const handleAvatar = (state, avatar) => {
  if (avatar) {
    localStorage.setItem(
      'member',
      JSON.stringify({
        ...state.data,
        imageUrl: avatar,
        avatar
      })
    );
    return {
      ...state,
      data: {
        ...state.data,
        imageUrl: avatar,
        avatar
      }
    };
  }

  return state;
};
